import { showJotaiDevtoolsAtom } from "@zapier/canvas-state";
import { createStore, useAtomValue } from "jotai";
import dynamic from "next/dynamic";

import "jotai-devtools/styles.css";

const DevTools = dynamic(
  () => import("jotai-devtools").then((mod) => mod.DevTools),
  {
    ssr: false,
  },
);

export function JotaiDevTools({
  store,
}: {
  store: ReturnType<typeof createStore>;
}) {
  const showJotaiDevtools = useAtomValue(showJotaiDevtoolsAtom);
  if (!showJotaiDevtools) {
    return null;
  }
  return <DevTools store={store} theme="dark" />;
}
